<template>
    <ValidationObserver ref="courseCodeRequestForm">
        <b-container class="mt-5">
            <b-row>
                <b-col>
                    <b-card class="p-5">
                        <b-row class="text-center">
                            <b-col cols="12" class="d-flex align-items-center justify-content-between mb-3">
                                <img src="../../../assets/img/BAU_Logo.png" height="75" alt="BAU Logo" />
                                <h6 class="mb-0" v-html="$t('bau_inspiration_text')"></h6>
                            </b-col>
                            <b-col>
                                <h4 class="mt-3 font-weight-bold">{{ $t('course_code_request_form') }}</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <p>
                                    {{ $t('course_code_request_form_description') }}
                                </p>
                                <hr class="yellow-line" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <ValidationProvider name="department_chair_name" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('department_chair_name')">
                                        <b-form-input v-model="form.department_chair_name" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="course_name" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('course_name')">
                                        <b-form-input v-model="form.course_name" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12">
                                <ValidationProvider name="course_level" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('course_level')">
                                        <b-form-checkbox-group
                                            v-model="form.course_level"
                                            class="d-flex flex-wrap b-from-group-horizontal"
                                            :options="courseLevelOptions"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            stacked
                                        ></b-form-checkbox-group>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12">
                                <ValidationProvider name="course_type" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('course_type')">
                                        <b-form-radio-group v-model="form.course_type" class="d-flex flex-wrap b-from-group-horizontal" :options="courseTypeOptions" :state="errors[0] ? false : (valid ? true : null)" stacked>
                                        </b-form-radio-group>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="course_status" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('course_status')">
                                        <b-form-radio-group v-model="form.course_status" class="d-flex flex-wrap b-from-group-horizontal" :options="courseStatusOptions" :state="errors[0] ? false : (valid ? true : null)" stacked>
                                        </b-form-radio-group>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" v-if="form.course_status === 'Existing'">
                                <ValidationProvider name="current_course_code" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('current_course_code')">
                                        <b-form-input v-model="form.current_course_code" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="rationale" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('rationale_for_request')">
                                        <b-form-textarea v-model="form.rationale" :state="errors[0] ? false : (valid ? true : null)" rows="5">
                                        </b-form-textarea>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="department_chair_signature" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('department_chair_signature')">
                                        <b-form-input v-model="form.department_chair_signature" :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="date" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date')">
                                        <select-date v-model="form.date" :validation-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <hr class="yellow-line" />
                                <h5 class="font-weight-bold">{{ $t('registrar_use_only') }}</h5>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('course_code_assigned')">
                                    <b-form-input v-model="form.course_code_assigned" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('date_entered_into_ois')">
                                    <select-date v-model="form.date_entered_ois" disabled/>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6">
                                <b-form-group :label="$t('institutional_effectiveness_specialist_signature')">
                                    <b-form-input v-model="form.specialist_signature" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6">
                                <b-form-group :label="$t('date')">
                                    <select-date v-model="form.specialist_date" disabled/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" class="text-center mt-3">
                                <p>www.bau.edu<br>1510 H Street NW, Suite #400 Washington, D.C., 20005 United States</p>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </ValidationObserver>
</template>
<script>
import SelectDate from "@/components/interactive-fields/SelectDate.vue";

export default {
    components: {
        SelectDate
    },
    data() {
        return {
            form: {
                department_chair_name: null,
                course_name: null,
                course_level: [], 
                course_type: null,
                course_status: null,
                current_course_code: null,
                rationale: null,
                department_chair_signature: null,
                date: null,
                course_code_assigned: null,
                date_entered_ois: null,
                specialist_signature: null,
                specialist_date: null
            },
            courseLevelOptions: [
                { value: 'Less than 100', text: 'Less than 100' },
                { value: '100', text: '100' },
                { value: '200', text: '200' },
                { value: '300', text: '300' },
                { value: '400', text: '400' },
                { value: '500', text: '500' },
                { value: '600', text: '600' }
            ],
            courseTypeOptions: [
                { value: 'Core', text: 'Core' },
                { value: 'Elective', text: 'Elective' },
                { value: 'GenEd', text: 'GenEd' }
            ],
            courseStatusOptions: [
                { value: 'New', text: 'New' },
                { value: 'Existing', text: 'Existing' }
            ]
        };
    },
    metaInfo() {
        return {
            title: this.$t("course_code_request_form"),
        };
    },
    methods: {}
};
</script>
<style scoped>
.yellow-line {
    border-top: 2px solid #ffc107; /* Yellow line */
}
.b-from-group-horizontal {
    gap:15px
}
</style>